import { render, staticRenderFns } from "./NormalPost.vue?vue&type=template&id=711a3f48&scoped=true&"
import script from "./NormalPost.vue?vue&type=script&lang=js&"
export * from "./NormalPost.vue?vue&type=script&lang=js&"
import style0 from "./NormalPost.vue?vue&type=style&index=0&id=711a3f48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711a3f48",
  null
  
)

export default component.exports